import { useNotify, useRedirect } from "ra-core";
import { Edit, SimpleForm } from "ra-ui-materialui";

import TextInputRA from "../components/TextInputRA";

const CategoryEdit = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const onSuccess = () => {
    notify("Edit successfully"); // default message is 'ra.notification.updated'
    redirect("list", props.basePath);
  };
  const onFailure = (error) => {
    console.error(error);
    if (error.code === 123) {
      notify(
        "Could not save changes: concurrent edition in progress",
        "warning"
      );
    } else {
      notify("ra.notification.http_error", "warning");
    }
    redirect("list", props.basePath);
  };
  return (
    <Edit
      mutationMode="pessimistic"
      onSuccess={onSuccess}
      onFailure={onFailure}
      {...props}
    >
      <SimpleForm>
        <TextInputRA label="Supplier name" source="name" />
        <TextInputRA label="Description" source="desc" />
        <TextInputRA label="Business type" source="business_type" />
        <TextInputRA label="Tax id" source="tax_id" />
        <TextInputRA label="Contact person 1" source="contact1" />
        <TextInputRA label="Contact person 2" source="contact2" />
        <TextInputRA label="Phone" source="phone" required type="phone" />
        <TextInputRA label="Email" source="email" />
        <TextInputRA label="Address" source="address" />
      </SimpleForm>
    </Edit>
  );
};

export default CategoryEdit;
